/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TReceiptDetailsGetModel, IMappers, TReceiptDetailsGetResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicV1ReceiptDetailsGetResponse } from '../../../entities/response/PublicV1ReceiptDetailsGetResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createReceiptDetailsGetModel(): TReceiptDetailsGetModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'dailyrent',
    pathApi: '/v1/receipt-details/get/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IReceiptDetailsGetOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchReceiptDetailsGet<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IReceiptDetailsGetOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TReceiptDetailsGetResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createReceiptDetailsGetModel(),
    config,
  )) as FetchResponse<TReceiptDetailsGetResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicV1ReceiptDetailsGetResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TReceiptDetailsGetResponse>;
}
